/*
 *
 * WidgetResultEnps reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_DATA_NPS_WATCHER,
  GET_DATA_NPS_SUCCESS,
  GET_DATA_NPS_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoading: true,
  getDataEnps: null,
})

function widgetResultNpsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_DATA_NPS_WATCHER:
      return state.set("isLoading", true).set("dataEnps", null)

    case GET_DATA_NPS_SUCCESS:
      return state.set("isLoading", false).set("dataEnps", action.payload)

    case GET_DATA_NPS_FAILED:
      return state.set("isLoading", false).set("dataEnps", null)

    default:
      return state
  }
}

export default widgetResultNpsReducer
